import { render } from "./IconSvg.vue?vue&type=template&id=0ac28adf&ts=true"
import script from "./IconSvg.vue?vue&type=script&lang=ts"
export * from "./IconSvg.vue?vue&type=script&lang=ts"

import "./IconSvg.vue?vue&type=style&index=0&id=0ac28adf&lang=css"

import exportComponent from "E:\\Project\\mc-cloud-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__